export enum UnscheduledBreakOptions {
  Both = 0,
  Unpaid = 1,
  Paid = 2,
  None = 3,
}
